<script>
  import { onMount } from 'svelte'
  import { Image } from 'smelte'
  import { slide } from 'svelte/transition'
  import { quadOut } from 'svelte/easing'
  import { push, location, link } from 'svelte-spa-router'
  import { User } from '../roles'
  import { icon_020_profile_png } from '../image-base64'
  import { userStore, is } from '../store'
  import { each } from 'svelte/internal';

  let user = new User()
  let showSubMenu = false
  let subMenuItems = []

  let mainMenuItems = [
    // {
    //   title: 'support',
    //   sub: [
    //     {
    //       type: 'component',
    //       title: 'MY FLEXLINK',
    //       ref: '/'
    //     }
    //   ]
    // }

    // {title: 'about us', ref: '/#'},
    // {title: 'solutions', ref: '/'},
    // {title: 'capabilities', ref: '/#'},
    // {title: 'services', ref: '/'},
    // {title: 'innovation', ref: '/#'},
  ]

  let adminMenu = [
    // {title: 'settings', ref: '/settings'}
  ]

  let links = [
    {title: 'Flexlink.com', ref: 'https://www.flexlink.com/en'},
    {title: 'My Flexlink', ref: 'https://my.flexlink.io/'},
    {title: 'Online Store', ref: 'https://my.flexlink.com/myflexlink/applicationstartauth.htm?app=1000'}
  ]

  let social = [
    {alt: 'Linked In', src: 'icon-header-linkedin.svg', ref: 'https://linkedin.com/company/flexlink/'},
    {alt: 'YouTube', src: 'icon-header-youtube.svg', ref: 'https://www.youtube.com/user/flexlinkmarketing'},
    {alt: 'Twitter', src: 'icon-header-twitter.svg', ref: 'https://twitter.com/FlexLink'}
  ]

  let checking

  onMount(() => {
    checking = user.checkAuth()
  })

  function loginHandler () {
    user.login()
  }

  function logoutHandler () {
    user.logout()
  }

  function getName () {
    return user.getUsername()
  }

  function mainItemClick (item) {
    if (item.sub) {
      showSubMenu = true
      subMenuItems = item.sub
      return
    }
    push(item.ref)
  }

  function subMenuClick (item) {
    showSubMenu = false
    subMenuItems = []
    if (item.type === 'external') {
      window.location.href = item.ref
    }
    push(item.ref)
  }


  // TODO: move to utils.js
  const onHideListPanel = () => showSubMenu = false

  function hideListAction (node, cb) {
    const onWindowClick = e => {
      if (!node.contains(e.target)) {
        cb()
      }
    }
    window.addEventListener('click', onWindowClick)
    return {
      destroy: () => {
        window.removeEventListener('click', onWindowClick)
      }
    }
  }
</script>

<!--
<nav></nav>
-->
<div class="flex px-12 justify-end pb-3 top-menu bg-white border-b border-gray-300">
  <div class="flex pt-5 space-x-5">
    {#each links as link}
      <a href={link.ref} >{link.title}</a>
    {/each}
  </div>
  <div class="flex pt-3 ml-5 space-x-1">
    {#each social as s}
      <a href={s.ref}><img src={`static/img/${s.src}`} alt={s.alt}/></a>
    {/each}
  </div>
</div>

<div class="main-menu bg-white" use:hideListAction={onHideListPanel}>

    <div class="row flex justify-start lg:justify-center items-center relative px-5">
      <div class="absolute left-0 mt-6 h-16" on:click={() => push('/')}>
        <Image src="/static/img/red.svg" alt="FlexLink AB logo" width={109} />
      </div>

      <div class="flex">
        {#each mainMenuItems as item}
          <div class="px-5 font-medium text-base tracking-widest cursor-pointer menu-item select-none"
              on:click={() => mainItemClick(item)}>
            {item.title.toUpperCase()}
          </div>
        {/each}

        {#if is($userStore.roles, 'ib_admin', 'admin')}
          {#each adminMenu as item}
            <div class="px-5 font-medium text-base tracking-widest cursor-pointer menu-item select-none"
                on:click={() => push(item.ref)}>
              {item.title.toUpperCase()}
            </div>
          {/each}
        {/if}
      </div>

      <div class="absolute right-0 h-full flex items-center pr-8">
        {#await checking then value}
          {#if $userStore.username == null && $location !== '/login' }
            <div class="flex items-center cursor-pointer select-none menu-item" on:click={loginHandler}>
              <span class="hidden sm:block uppercase font-medium text-base tracking-widest mr-1">sign in</span>
              <img src={icon_020_profile_png} alt="">
            </div>
          {/if}
          {#if $userStore.username != null && $location !== '/login' }
            <div class="flex items-center cursor-pointer select-none" on:click={logoutHandler}>
              <span class="hidden sm:block uppercase font-medium text-base tracking-widest menu-item mr-1">{getName()}</span>
              <img src={icon_020_profile_png} alt="">
            </div>
          {/if}
        {/await}
      </div>
    </div>

  {#if showSubMenu}
    <div class="sub-menu absolute left-0 px-10 py-5 bg-gray-300 z-10 w-screen text-left flex justify-start items-center
                font-medium text-base tracking-widest cursor-pointer"
         transition:slide={{duration: 500, easing: quadOut}}>
      {#each subMenuItems as item}
        <div class="item px-5 uppercase" on:click={() => subMenuClick(item)}>
          {item.title}
        </div>
      {/each}
    </div>
  {/if}
</div>

<style>
    nav {
        height: 40px;
    }

    .main-menu {
        padding-left: 40px;
        padding-right: 40px;
    }

    .main-menu > .row {
        height: 80px;
    }

    .menu-item:hover {
        color: #C81034;
    }

    h1 {
        color: #ff3e00;
        text-transform: uppercase;
        font-size: 4em;
        font-weight: 300;
        letter-spacing: -1.5px;
    }

    .sub-menu > .item:hover {
        color: #C81034;
    }

    @media (max-width: 768px) {
        h1 {
            font-size: 3em;
        }
    }
</style>

